import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=b95f1802&scoped=true"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=b95f1802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95f1802",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleModal.vue
// module id = 1418
// module chunks = 31